import { Workflow } from "~/api";

export interface UseWorkflowArgs {
  /** Function to update the status of the workflow */
  updateStatus: (status: string) => void;
  updateStatusFromNameStamp: (status: string) => void;
  getWorkflowStatus: () => string;
  getWorkflow: () => Workflow | undefined;
  /** Function to permanently delete the workflow instance */
  deleteWorkflow?: () => Promise<void>;
}

export interface WorkflowState {
  updateWorkflowStatus: (status: string) => Promise<void>;
  updateWorkflowStatusFromNameStamp: (status: string) => Promise<void>;
  getWorkflowStatus: () => string;
  getWorkflow: () => Workflow | undefined;
  /** Permanently delete the workflow instance */
  deleteWorkflow?: () => Promise<void>;
}

export function useWorkflow({
  updateStatus,
  updateStatusFromNameStamp,
  getWorkflowStatus,
  getWorkflow,
  deleteWorkflow,
}: UseWorkflowArgs): WorkflowState {
  async function updateWorkflowStatus(status: string) {
    await updateStatus(status);
  }

  async function updateWorkflowStatusFromNameStamp(status: string) {
    await updateStatusFromNameStamp(status);
  }

  return {
    updateWorkflowStatus,
    updateWorkflowStatusFromNameStamp,
    getWorkflowStatus,
    getWorkflow,
    deleteWorkflow,
  };
}
